module.exports = __webpack_public_path__ + "img/vcay.83df9dc0.jpg";